import { IFullTemplate } from '../../config/interfaces';

/**
 * Store sub context for template data
 */
const TemplateContext = {
  templateById: {} as IFullTemplate,
  selectedQuestionId: '',
  editQuestion: false,
  prevTemplate: ''
};

export default TemplateContext;
